


































import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, State, Mutation } from "vuex-class";

import vSelect from "vue-select";

import MobileEventQueueList from "./MobileEventQueueList.vue";

import { AlarmQueueFilterID, AlarmQueueFilter } from "@/store/eventqueue/types";
import { FeaturesList } from "@/store/types";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		"v-select": vSelect,
		"mobile-event-queue-list": MobileEventQueueList
	}
})
export default class MobileEventQueue extends Vue {

	@State(state => state.User.userPermissions) permissions: {
		[permissionName: string]: number | undefined;
	};

	// Feature flag
	@Getter("getFeaturesList") featuresList: FeaturesList;

	@Eventqueue.Mutation("setActiveFilter") setActiveFilter!: (alarmFilter: AlarmQueueFilterID) => void;
	@Eventqueue.Getter("getActiveFilterID") activeFilterID!: AlarmQueueFilterID;

	@Eventqueue.Getter("getAlarmQueueFilters") allAlarmQueueFilters: AlarmQueueFilter[]
	@Eventqueue.Action fetchAlarmQueueFilters: () => void;

	private allFilters: AlarmQueueFilter[] = [];

	get selectedAlarmQueueFilter(): AlarmQueueFilter
	{
		let alarmQueueFilter = this.allFilters.find(c => 
										(!c.regionID && !this.activeFilterID.regionId) // activeFilterID.regionId's default is null, 
																						// but alarmQueueFilterID's default is zero, 
																						// but sadly null != 0 in javascript, so need this 
									|| c.alarmQueueFilterID == this.activeFilterID.filterId)
		return alarmQueueFilter;
	}
	set selectedAlarmQueueFilter(value: AlarmQueueFilter)
	{

		this.setActiveFilter({
			filterId: value.alarmQueueFilterID,
			regionId: value.regionID
		});
	}

	public get isEventQueueEnabled() : boolean {
		return this.featuresList.Mobile.EventQueue;
	}

	private get canProcessAlarms() {
		return this.permissions && this.permissions.hasOwnProperty("canProcessAlarms") && this.permissions["canProcessAlarms"];
	}

	public async mounted() {

		await this.fetchAlarmQueueFilters();
		this.allFilters = this.allAlarmQueueFilters;
	}
}
